module.exports = __webpack_public_path__ + "img/teaser_pferd-hund.25f78669.jpg";